import { render, staticRenderFns } from "./PannelTwo.vue?vue&type=template&id=8a852022&scoped=true&"
import script from "./PannelTwo.vue?vue&type=script&lang=js&"
export * from "./PannelTwo.vue?vue&type=script&lang=js&"
import style0 from "./PannelTwo.vue?vue&type=style&index=0&id=8a852022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a852022",
  null
  
)

export default component.exports